var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.action)?_c('article-content',{attrs:{"boardId":_vm.info,"articleId":_vm.article,"category":_vm.category}}):_c('article-form',{attrs:{"boardId":_vm.info,"articleId":_vm.article,"category":_vm.category,"action":_vm.action}})}
var staticRenderFns = []

export { render, staticRenderFns }